module.exports = "<p>testm works!</p>\n"